(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zf-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.zf-product').forEach(function (root) {
    var track = root.querySelector('[data-zf-track]');
    var thumbs = root.querySelectorAll('[data-zf-thumb]');
    if (track) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var i = Number(thumb.dataset.zfThumb);
          track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
        });
      });
      track.addEventListener(
        'scroll',
        function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          thumbs.forEach(function (t, n) {
            t.classList.toggle('is-active', n === i);
          });
        },
        { passive: true }
      );
    }

    root.querySelectorAll('[data-zf-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = root.querySelector('input[name="quantity"]');
        var next = Math.max(1, Number(input.value || 1) + Number(btn.dataset.zfQty));
        input.value = next;
      });
    });

    // Shipping protection: ak je zaškrtnutá, pridá do košíka produkt aj ochranu naraz
    var form = root.querySelector('[data-zf-form]');
    var protect = root.querySelector('[data-zf-protect]');
    if (form && protect) {
      form.addEventListener('submit', function (event) {
        if (!protect.checked) return;
        event.preventDefault();
        var data = new FormData(form);
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              { id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1) },
              { id: Number(protect.value), quantity: 1 },
            ],
          }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart');
            window.location.href = window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart' : '/cart';
          })
          .catch(function () {
            protect.checked = false;
            form.submit();
          });
      });
    }

    var sticky = root.querySelector('[data-zf-sticky]');
    var mainBtn = root.querySelector('[data-zf-atc]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var hidden = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', hidden);
      }).observe(mainBtn);
      var stickyBtn = sticky.querySelector('[data-zf-sticky-btn]');
      stickyBtn.addEventListener('click', function () {
        if (!mainBtn.disabled) {
          mainBtn.click();
        } else {
          mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
